/** @format */

import MainHeader from '../Components/MainHeader';
import { useState, useEffect, useRef } from 'react';
import './BoardItemDetail.css';
import axios from 'axios';
import CommentItem from '../Components/CommentItem';
import { useNavigate } from 'react-router-dom';

const BoardItemDetail = () => {
  const navigate = useNavigate();
  let rawDetailInfo = {};
  let rawDeleteInfo = {};
  let postId = '';
  const [Detail, setDetail] = useState([]);
  const [deletePw, setDeletePw] = useState('');

  const writerInput = useRef();
  const contentInput = useRef();
  const pwInput = useRef();
  const deletePwInput = useRef();

  const parentFunction = (x) => {}; // 모달메뉴용 더미함수

  const Params = () => {
    const current = decodeURI(window.location.href);
    const search = current.split('/')[4]; //4번째 '/'뒤에있는 값 가져옴
    return search;
  };

  postId = Params();

  const fetDetail = async () => {
    const OPEN_API_DOMAIN = 'http://yapyap.r-e.kr:8090/getPost?postId=';
    const rawReasponse = await fetch(`${OPEN_API_DOMAIN}${postId}`);
    const jsonResponse = await rawReasponse.json();
    return jsonResponse;
  };

  const postDelete = async () => {
    const OPEN_API_DOMAIN = 'http://yapyap.r-e.kr:8090/deletePost?postId=';
    const rawReasponse = await fetch(
      `${OPEN_API_DOMAIN}${postId}&pw=${deletePw}`,
      { method: 'DELETE' }
    );
    const jsonResponse = await rawReasponse.json();
    return jsonResponse;
  };

  useEffect(() => {
    rawDetailInfo = fetDetail();
    rawDetailInfo.then((value) => setDetail(value));
  }, []);
  console.log(Detail);

  const handleChangeState = (e) => {
    console.log(e.target.name);
    console.log(e.target.value);

    setState({
      ...state,
      [e.target.name]: e.target.value,
    });
  };

  const [state, setState] = useState({
    content: '',
    writer: '',
    pw: '',
    postId: postId,
  });

  const handleSubmit = () => {
    if (state.writer.length < 1) {
      writerInput.current.focus();
      return;
    }
    if (state.content.length < 5) {
      contentInput.current.focus();
      return;
    }
    if (state.pw.length < 4) {
      pwInput.current.focus();
      return;
    }
    console.log(state);
    axios
      .post('https://yapyap.r-e.kr:8090/postComment', JSON.stringify(state), {
        headers: {
          'Content-Type': `application/json`,
        },
      })
      .then((res) => {
        console.log(res);
      });
    alert('등록 성공!');
    setState({
      content: '',
      writer: '',
      pw: '',
    });
    window.open(`http://localhost:3000/Board/${postId}`, '_self');
  };

  const deleteSubmit = () => {
    if (deletePw.length < 1) {
      deletePwInput.current.focus();
      return;
    }
    axios
      .delete(
        `https://yapyap.r-e.kr:8090/deletePost?postId=${postId}&pw=${deletePw}`
      )
      .then((res) => {
        console.log(res);
        if (res.data.responseCode == '200 OK') {
          setDeletePw('');
          window.confirm('삭제성공');
          navigate('/Board');
        } else {
          setDeletePw('');
          window.confirm('삭제실패');
        }
      });
  };

  return (
    <div>
      <div>
        <MainHeader parentFunction={parentFunction} />
      </div>
      <div className="boardItemDetailBody">
        <div className="detailPageLeft"></div>
        <div className="detailPageBody">
          <div className="detailPageTitleBox">
            <div className="detailPageTitleBoxTop">
              <div className="detailPageTitle">{Detail.title}</div>
            </div>
            <div className="detailPageTitleBoxMid">
              <div></div>
              <div>{Detail.writeDate}</div>
            </div>
            <div className="detailPageTitleBoxBottom">
              <div>{Detail.postId}</div>
              <div></div>
            </div>
          </div>
          <div className="detailPageContent">{Detail.content}</div>
          <div className="commentInputarea">
            <div className="deleteBox">
              <div>비밀번호:</div>
              <input
                ref={deletePwInput}
                name="deletePw"
                value={deletePw}
                onChange={(e) => setDeletePw(e.target.value)}
              />
              <button onClick={deleteSubmit}>삭제하기</button>
            </div>
            <div className="commentInputTop">
              <input
                ref={writerInput}
                name="writer"
                value={state.writer}
                onChange={handleChangeState}
              />
              <input
                ref={pwInput}
                name="pw"
                value={state.pw}
                onChange={handleChangeState}
              />
            </div>
            <div className="commentInputBottom">
              <textarea
                ref={contentInput}
                name="content"
                value={state.content}
                onChange={handleChangeState}
              />
              <button onClick={handleSubmit}>등록</button>
            </div>
          </div>
          <div className="commentTextarea">
            <div>
              {Detail.commentList &&
                Detail.commentList.map((it) => (
                  <CommentItem
                    key={it.commentId}
                    {...it}
                  />
                ))}
            </div>
          </div>
        </div>
        <div className="detialPageRight"></div>
      </div>
    </div>
  );
};

export default BoardItemDetail;
